import React, { PureComponent, Children } from 'react';
import classnames from 'classnames';

import './TableWidgetChooser.styl';

class TableWidgetChooser extends PureComponent {
  state = {
    activeIndex: 1
  }

  onClickButton(evt, activeIndex) {
    this.setState({
      activeIndex
    });
  }

  renderButtons() {
    return (
      <div className="btn-group">
        {this.props.children.map((c, i) => {
          const buttonClasses = classnames('btn', { active: this.state.activeIndex === i });

          return (
            <button
              className={buttonClasses}
              onClick={evt => this.onClickButton(evt, i)}
              key={`tablechooser-btn-${i}`}
            >
              <div className="label">{c.props.label}</div>
            </button>
          );
        })}
      </div>
    );
  }

  render() {
    const children = Children.toArray(this.props.children)

    return (
      <div className="table__chooser">
        {this.renderButtons()}
        {children[this.state.activeIndex]}
      </div>
    );
  }
}

export default TableWidgetChooser;
